/** DriveOps brand tokens — ported from mobile `theme/index.ts`. */
export const colors = {
  PRIMARY_PURPLE: '#5D739B',
  SECONDARY_BLUE: '#4576E5',
  WHITE: '#FFFFFF',
  DARK_NAVY: '#081933',
  PALE_BLUE: '#F4F7FD',
  LAVENDER: '#E9F0FC',
  GREEN: '#8BC135',
  BEIGE: '#EBFCC0',
  WARNING_ORANGE: '#EDA73D',
  PEACH: '#FFF0DF',
  BLACK: '#000000',
  LIGHT_PERIWINKLE: '#C1D1EA',
  DARK_NAVY_20: 'rgba(8, 25, 51, 0.2)',
  DEEP_INDIGO: '#1A3094',
  SOFT_SLATE: '#ACB7CD',
  OFF_WHITE: '#FCFCFE',
  LIGHT_GRAY: '#E6E6E6',
  ROYAL_BLUE: '#3963C1',
  RED: '#d70b29',
  SOFT_BLUE: '#99aed3',
  SOFT_PERIWINKLE: '#A2BAF2',
} as const

export type ColorKey = keyof typeof colors

export const fonts = {
  family: '"Geologica", "Segoe UI", system-ui, sans-serif',
} as const
